import { useEffect, useState, useCallback, useMemo, useRef } from 'react'
import Header from './header'
import List from './list'
import ProductInfo, { getErrorMessage } from './productInfo'
import AssociatedGoods from './associatedGoods'
import {
  getStandardProductsList,
  addStandardProducts,
  StandardProduct as StandardProductType,
  putStandradProduct,
  deleteStandradProduct,
  refreshStandradProduct,
  addStandradProductsById,
  getStandradProductsTasks,
  getStarStyleInfoList,
  StarInfo,
} from '../../services/standardProduct'
import { message, Modal, Descriptions } from 'antd'
import ImportModal from './importModal'
import TaskList from './taskList'
const PAGE_SIZE = 10


const StandardProduct = () => {
  const [queryData, setQueryData] = useState<Record<string, any>>({})
  const [loading, setLoading] = useState(false)
  const [dataSource, setDataSource] = useState<StandardProductType[]>([])
  const [productInfoVisible, setProductInfoVisible] = useState(false)
  const [associatedGoodsId, setAssociatedGoodsId] = useState<string>('')
  const [productInfo, setProductInfo] = useState<StandardProductType | null>(null)
  const [importVisible, setImportVisible] = useState(false)
  const modalRef = useRef<ReturnType<typeof Modal.error> | null>(null)
  const [pagination, setPagination] = useState({
    pageSize: PAGE_SIZE,
    current: 1,
    total: 0
  })
  const [starList, setStarList] = useState<StarInfo[]>([])
  /**
   * 点击新增按钮
   */
  const onClickaddButton = () => {
    setProductInfoVisible(true)
    setProductInfo(null)
  }

  /**
   * 点击查询按钮
   * @param { QueryData } data 查询数据
   */
  const queryHandler = (data) => {
    setQueryData(data)
    setPagination((pre) => ({
      ...pre,
      total: 0,
      current: 1
    }))
  }

  /**
   * 隐藏标品商品弹窗
   */
  const onProductInfoCancel = () => {
    setProductInfoVisible(false)
    setProductInfo(null)
  }

  /**
   * 点击编辑按钮
   * @param  { StandardProductInfo } info 标品信息
   */
  const onClcikEditorButton = (info: StandardProductType) => {
    setProductInfoVisible(true)
    setProductInfo(info)
  }

  /**
   * 删除标品
   * @param { String } id 标品id
   */
  const deleteHandler = (id) => {
    deleteStandradProduct(id)
      .then(() => {
        setPagination(pre => ({
          ...pre,
          total: 0,
          current: 1,
        }))
        if(pagination.current === 1) {
          getDataSource()
        }
        message.success('删除成功')
      })
      .catch(error => message.error(getErrorMessage(error)))
  }
  /**
   * 刷新标品
   * @param { String } id 标品id
   */
  const refreshHandler = (id) => {
    refreshStandradProduct(id)
      .then(getDataSource)
      .catch(error => message.error(getErrorMessage(error)))
  }

  /**
   * 删除自动关联商品
   * @param { String } id 
   */

  const onDeleteAssociatedGoods = () => {
    getDataSource()
  }
  
  const onAddAssociatedGoods = () => {
    getDataSource()
  }

  const onClickQuantityOfGoods = (id: string) => {
    setAssociatedGoodsId(id)
  }

  const onQuantityOfGoodsModalCancel = () => {
    setAssociatedGoodsId('')
  }

  const onAddHandler = (apiData) => {
    return new Promise((resolve, reject) => {
      addStandardProducts(apiData)
        .then(res => {
          setPagination(pre => ({
            ...pre,
            total: 0,
            current: 1,
          }))
          if (pagination.current === 1) {
            getDataSource()
          }
          resolve(undefined)
        })
        .catch((error) => {
          message.error(getErrorMessage(error))
          reject()
        })
    })  
  }

  const onEditorHandler = (id, apiData) => {
    return new Promise((resolve, reject) => {
      putStandradProduct(id, apiData)
        .then(res => {
          getDataSource()
          resolve(undefined)
        })
        .catch(error => {
          message.error(getErrorMessage(error))
          reject()
        })
    })  
    
  }

  const { current, pageSize } = pagination
  const getDataSource = useCallback(() => {
    setLoading(true)
    getStandardProductsList({
      ...queryData,
      from: (current - 1) * pageSize,
      to: current * pageSize,
    })
      .then(({ data }) => {
        setDataSource(data.list || [])
        setPagination(pre => ({
          ...pre,
          total: data.count,
        }))
      })
      .catch(error => message.error(getErrorMessage(error)))
      .finally(() => setLoading(false))
  }, [queryData, current, pageSize])

  const onPaginationChange = (page, pageSize) => {
    setPagination((pre) => ({
      ...pre,
      current: page,
      pageSize: pageSize
    }))
  }

  const paginationData = useMemo(() => {
    return {
      ...pagination,
      onChange: onPaginationChange,
    }
  }, [pagination])

  useEffect(() => {
    getDataSource()
    getStarList()
  }, [getDataSource])
  
  const getStarList = useCallback(() => {
      getStarStyleInfoList().then((res)=> {
          setStarList(res['data']['items'])
      }).catch((err) => {

      })
  },[])


  const onImportModalCancel = () => {
    setImportVisible(false)
  }

  const showImportModal = () => {
    setImportVisible(true)
  }

  const showTaskId = (id: string) => {
    return (
      <Descriptions  bordered size="small" column={1}>
          <Descriptions.Item key={id}>{id}</Descriptions.Item>
      </Descriptions>
    )
  }

  const showModal = (config: Record<string, any>) => {
    if (modalRef.current) {
      modalRef.current.update(config)
    } else {
      modalRef.current = Modal.info(config)
    }
  }

  const importHandler = (ids: string[]) => {
    addStandradProductsById(ids).then(({ data }) => {
      onImportModalCancel()
      if(data.taskId) {
        showModal({
          content: showTaskId(data.taskId),
          visible: true,
          title: '任务ID',
          width: '60%',
        })
      }
    }).catch(err => {
      message.error(err.message)
    })
  }


  const onViewTasks = () => {
    return new Promise((resolve, reject) => {
      getStandradProductsTasks().then(res => {
        resolve(true)
        showModal({
          content: <TaskList dataSource={res.data || []} />,
          visible: true,
          title: '任务列表',
          width: '90%',
        })
      }).catch(err => {
         message.error(getErrorMessage(err))
        reject(false)
      })
    })
    
  }

  useEffect(() => {
    return () => {
      modalRef.current?.destroy()
      modalRef.current = null
    }
  }, [])

  

  return (
    <>
      <Header
        onQuery={queryHandler}
        onAdd={onClickaddButton}
        onImport={showImportModal}
        onViewTasks={onViewTasks}
      />
      <List
        onClcikEditorButton={onClcikEditorButton}
        onDelete={deleteHandler}
        onRefresh={refreshHandler}
        onClickQuantityOfGoods={onClickQuantityOfGoods}
        dataSource={dataSource}
        loading={loading}
        pagination={paginationData}
      />
      <ProductInfo
        visible={productInfoVisible}
        onCancel={onProductInfoCancel}
        productInfo={productInfo}
        onAdd={onAddHandler}
        onEditor={onEditorHandler}
        starList={starList}
      />
      <AssociatedGoods
        onDeleteAssociatedGoods={onDeleteAssociatedGoods}
        id={associatedGoodsId}
        onCancel={onQuantityOfGoodsModalCancel}
        onAddAssociatedGoods={onAddAssociatedGoods}
      />
      <ImportModal visible={importVisible} onCancel={onImportModalCancel} onOK={importHandler} />
    </>
  )
}

export default StandardProduct